import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./tabbed-navigation.styles.scss";
import useMediaQuery from "../hooks/use-media-query";

const propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      shortLabel: PropTypes.string,
      longLabel: PropTypes.string,
      icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
      disabled: PropTypes.bool
    })
  ).isRequired,
  activeTabId: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  testIdPrefix: PropTypes.string,
  iconStyle: PropTypes.oneOf(["inline", "circle"])
};

const TabbedNavigation = ({
  tabs,
  activeTabId,
  onTabChange,
  className = "",
  testIdPrefix = "tab",
  iconStyle = "circle"
}) => {
  const isLargeViewport = useMediaQuery("(min-width: 1200px)");
  const getLayoutClass = () => {
    const tabCount = tabs.length;
    const layoutMap = {
      1: "single",
      2: "two",
      3: "three",
      4: "four"
    };
    return `tabbed-navigation--${layoutMap[tabCount] || "many"}`;
  };

  const handleTabClick = tab => {
    if (!tab.disabled) {
      onTabChange(tab.id);
    }
  };

  const getTabLabel = (tab, isLarge) => {
    if (isLarge) {
      return tab.longLabel || tab.shortLabel;
    }
    return tab.shortLabel;
  };

  const containerClassName = classNames("tabbed-navigation", getLayoutClass(), className);

  return (
    <div className={containerClassName}>
      {tabs.map(tab => {
        const tabClassName = classNames("tabbed-navigation__tab", {
          "tabbed-navigation__tab--active": tab.id === activeTabId,
          "tabbed-navigation__tab--disabled": tab.disabled
        });
        const label = getTabLabel(tab, isLargeViewport);
        return (
          <button
            key={tab.id}
            type="button"
            className={tabClassName}
            onClick={() => handleTabClick(tab)}
            disabled={tab.disabled}
            data-testid={`${testIdPrefix}-${tab.id}`}
          >
            {iconStyle === "inline" && tab.icon && (typeof tab.icon === "string" ? <i className={tab.icon} /> : tab.icon)}
            {iconStyle === "circle" && tab.icon && (
              <div className="tabbed-navigation__icon-circle">
                <i className={tab.icon} />
              </div>
            )}
            {label && <span className="tabbed-navigation__tab-label">{label}</span>}
          </button>
        );
      })}
    </div>
  );
};

TabbedNavigation.propTypes = propTypes;

export default TabbedNavigation;
